import { mapState, mapActions } from "vuex";

export const SetMortgageSubmitted = {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      mortgage: state => state.forms.mortgage
    })
  },
  methods: {
    ...mapActions({
      getMortgage: "forms/getMortgage"
    }),
    calculateMortgage() {
      // let SubmitDataFiltered = {
      //   first: this.SubmitData.widgets.firstIncome
      //     ? this.SubmitData.widgets.firstIncome
      //     : "",
      //   second: this.SubmitData.widgets.secondIncome
      //     ? this.SubmitData.widgets.secondIncome
      //     : ""
      // };
      // let first = SubmitDataFiltered.first;
      // let second = SubmitDataFiltered.second;
      // if (second === "") {
      //   second = 0;
      // }
      // this.getMortgage({ first: first, second: second }).then(res => {
      //   if (res.data.data.error || res.data.error) {
      //     document.getElementById("max-mortgage").innerHTML =
      //       "Cannot Calculate";
      //     document.getElementById("brut-mortgage").style = "display:none";
      //     document.getElementById("mortgage-rente").style = "display:none";
      //     document.getElementById("mortgage-br").style = "display:none";
      //     if (this.overview.filter(x => x.id === 58).length > 0) {
      //       this.overview.filter(x => x.id === 58)[0].total = 0;
      //       this.overview.filter(x => x.id === 58)[0].yearly = 0;
      //       this.overview.filter(x => x.id === 58)[0].title = "Mortgage";
      //       this.overview.filter(x => x.id === 58)[0].packages = [];
      //     }
      //   } else {
      //     this.handleMortgageWidget();
      //   }
      // });
    },

    handleMortgageWidget() {
      (document.getElementById("firstIncome").value = this.SubmitData.widgets
        .firstIncome
        ? this.SubmitData.widgets.firstIncome
        : ""),
        (document.getElementById("secondIncome").value = this.SubmitData.widgets
          .secondIncome
          ? this.SubmitData.widgets.secondIncome
          : "");

      document.getElementById("brut-mortgage").style = "";
      document.getElementById("mortgage-rente").style = "";
      document.getElementById("mortgage-br").style = "";
      //max-mortgage
      document.getElementById("max-mortgage").innerHTML =
        "€ " + this.formatPrice(this.mortgage.max_mortgage);
      //brut-mortgage
      document.getElementById("brut-mortgage").innerHTML = this.formatPrice(
        this.mortgage.monthly_charge_gross
      );
      //rente-mortgage
      let a = document.getElementById("mortgage-rente").innerHTML;
      let b = a.replace("%s", this.mortgage.interest_rate + "%");
      let c = a.replace("0%", this.mortgage.interest_rate + "%");
      document.getElementById("mortgage-rente").innerHTML = b;
      if (this.lang === "nl") {
        document.getElementById("mortgage-rente").innerHTML = c;
      }

      this.handleMortgageOverview();
    },

    handleMortgageOverview() {
      if (this.overview.filter(x => x.id === 58).length > 0) {
        this.overview.filter(
          x => x.id === 58
        )[0].total = this.mortgage.monthly_charge_gross;
        this.overview.filter(x => x.id === 58)[0].yearly =
          this.mortgage.monthly_charge_gross * 12;
        this.overview.filter(x => x.id === 58)[0].title = "Mortgage";
        this.overview.filter(x => x.id === 58)[0].supplier.title =
          "Mortgage Advice";
        this.overview.filter(x => x.id === 58)[0].packages = [
          {
            category_name: { en: "Max Mortgage", nl: "Max Mortgage" },
            name:
              '{"nl":"€ ' +
              this.formatPrice(this.mortgage.max_mortgage) +
              '","en":"€ ' +
              this.formatPrice(this.mortgage.max_mortgage) +
              '"}'
          },
          {
            category_name: { en: "Interest Rate", nl: "Rente" },
            name:
              '{"nl":"' +
              this.mortgage.interest_rate +
              '%","en":"' +
              this.mortgage.interest_rate +
              '%"}'
          },
          {
            category_name: {
              en: "Monthly Gross Charges",
              nl: "Bruto Maandlasten"
            },
            name:
              '{"nl":"€ ' +
              this.formatPrice(this.mortgage.monthly_charge_gross) +
              '","en":"€ ' +
              this.formatPrice(this.mortgage.monthly_charge_gross) +
              '"}'
          }
        ];
      }
    },
    async setMortgageSubmitted() {
      if (this.SubmitData.widgets.firstIncome) {
        this.calculateMortgage();
      }
    }
  }
};
